import { connect } from 'react-redux';
import { ParticipantViewModel } from 'stageclip-common';

import { createModalCloseAction } from 'actions/modalActions';
import { SimpleModalId } from 'constants/modalId';
import { normalizeParticipant } from 'api/normalizers/participantNormalizers';
import { createEditParticipant } from 'api/participants/participants.actions';
import { InternalActionTypes } from 'constants/actionTypes';
import { BlacklistConfirmationModalContent } from './BlacklistConfirmationModalContent';
import { callApi } from 'helpers/callApi/callApi';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { getItem } from 'store/selectors';

const mapStateToProps = (state: ClippingPlatformState, { participantId }: any) => ({
  participant: participantId ? getItem(state.entities.participants, participantId) : {},
});

const mapDispatchToProps = (dispatch: Function) => ({
  updateParticipant: (id: string, nextBlacklistStatus: boolean) => {
    callApi({
      action: () =>
        dispatch(
          createEditParticipant({
            id,
            // @ts-ignore
            blacklist: nextBlacklistStatus,
          }),
        ),
      onSuccess: ({ payload }: { payload: ParticipantViewModel }) => {
        dispatch({
          type: nextBlacklistStatus
            ? InternalActionTypes.ParticipantBlacklistAdded
            : InternalActionTypes.ParticipantBlacklistRemoved,
          eventId: payload.eventId,
          result: normalizeParticipant(payload),
        });

        dispatch(createModalCloseAction(SimpleModalId.ParticipantBlacklistConfirmation));
      },
    });
  },
});

export const BlacklistConfirmationModalContentContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BlacklistConfirmationModalContent);
